export default "__VITE_ASSET__d6ab7d9f__"